import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Align Horizontal Center"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-align-horizontal-center',
    templateUrl: './icon-align-horizontal-center.component.html',
    styleUrls: ['./icon-align-horizontal-center.component.scss'],
    standalone: false
})
export class IconAlignHorizontalCenterComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
